// import clone from 'clone';
import actions from './actions';
const initState = {
  passengers: [],
  passenger: {},
  isDelete: false,
};

export default function cardReducer(state = initState, { type, ...action }) {
  switch (type) {
    case actions.GET_PASSENGER_DATAS_REDUCER: {
      return {
        ...state,
        passengers: action.data,
        isDelete: false,
      };
    }
    case actions.GET_ALLPASSENGER_DATAS_REDUCER: {
      return {
        ...state,
        passengers: action.data,
        isDelete: false,
      };
    }
    case actions.UPDATE_PASSENGER_REDUCER: {
      return {
        ...state,
        isDelete: true,
      };
    }
    case actions.DELETE_PASSENGER_REDUCER: {
      return {
        ...state,
        isDelete: true,
      };
    }
    default:
      return state;
  }
}
